import script from "./PoliciesAndProceduresView.vue?vue&type=script&setup=true&lang=js"
export * from "./PoliciesAndProceduresView.vue?vue&type=script&setup=true&lang=js"

import "./PoliciesAndProceduresView.vue?vue&type=style&index=0&id=818002f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-818002f0"]])

export default __exports__